import { Box, Grid } from '@mui/material'
import React from 'react'
import styles from "./survey.module.css"

function SurveyTitle() {
  return (
    <Grid className={styles.TitleHeaderContainer}>
    <Box>回收桶服務意見表格</Box>
    <Box className={styles.textAlign}>
        <Box>Recycling Bins Collection Service Online Form</Box>
    </Box>
</Grid>
  )
}

export default SurveyTitle